import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { TOAST_SHOW } from "../Actions/ToastAction";
import {
  GET_PROGRAM_CHARTDATA_SUCCESS,
  GET_PROGRAM_CHARTDATA_FAILED,
  GET_PRACTITIONER_DETAIL_CHART_SUCCESS,
  GET_PRACTITIONER_DETAIL_CHART_FAILED,
} from "../Actions/OverviewAction";
import decryptResponse from "../../Components/Decrypt";

export function* getOverviewChartSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `/get-overview-graph-data/${action.payload}`
    );
    const { data } = response?.data;
    let decryptData = decryptResponse(data);
    yield put({ type: GET_PROGRAM_CHARTDATA_SUCCESS, payload: decryptData });
  } catch (e) {
    yield put({ type: GET_PROGRAM_CHARTDATA_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
export function* getPractitionerOverviewChartSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `/get-practitioner-details-graph`,
      action.payload
    );
    const { data } = response?.data;
    let decryptData = decryptResponse(data);

    yield put({
      type: GET_PRACTITIONER_DETAIL_CHART_SUCCESS,
      payload: decryptData,
    });
  } catch (e) {
    yield put({ type: GET_PRACTITIONER_DETAIL_CHART_FAILED });
    return yield put({
      type: TOAST_SHOW,
      payload: {
        message: e.response.data.errors.Error.message,
        severity: "error",
      },
    });
  }
}
